import { render, staticRenderFns } from "./Searchbtn.vue?vue&type=template&id=4ce4d13e&"
import script from "./Searchbtn.vue?vue&type=script&lang=js&"
export * from "./Searchbtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports